export default {
	intro          : false,
	aboutHukos     : false,
	pronounceActive: true
}
